import { AfterViewInit, Directive, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Constructor } from '../type/constructor';

export function PaginatorMixin<TBase extends Constructor>(Base: TBase) {
    return class Paginator extends Base {
        public pagingPageSize: number = 10;
        public pagingItemCount: number = 0;

        constructor(...args: any[]) {
            super(...args);
        }

        public handlePaging(
            paginator: MatPaginator,
            after: (offset: number) => void
        ) {
            paginator.page.subscribe((page) => {
                after(page.pageIndex * page.pageSize);
            });
        }
    };
}
